export const getSwrResourceFromKey = (
  key: string,
  onParseError?: (error: unknown) => void,
): string => {
  try {
    return key
      .split(",")
      .filter(Boolean)
      .slice(1)
      .map((segment) => JSON.parse(segment) as string)
      .join(",");
  } catch (error) {
    onParseError?.(error);

    return key;
  }
};
